export const GET_TOPN_COLOR_REQUEST = "GET_TOPN_COLOR_REQUEST";
export const GET_TOPN_COLOR_SUCCESS = "GET_TOPN_COLOR_SUCCESS";
export const GET_TOPN_COLOR_FAILURE = "GET_TOPN_COLOR_FAILURE";

export const UPDATE_TOPN_COLOR_REQUEST = "UPDATE_TOPN_COLOR_REQUEST";
export const UPDATE_TOPN_COLOR_SUCCESS = "UPDATE_TOPN_COLOR_SUCCESS";
export const UPDATE_TOPN_COLOR_FAILURE = "UPDATE_TOPN_COLOR_FAILURE";

export const ADD_TOPN_COLOR_REQUEST = "ADD_TOPN_COLOR_REQUEST";
export const ADD_TOPN_COLOR_SUCCESS = "ADD_TOPN_COLOR_SUCCESS";
export const ADD_TOPN_COLOR_FAILURE = "ADD_TOPN_COLOR_FAILURE";

export const DELETE_TOPN_COLOR_REQUEST = "DELETE_TOPN_COLOR_REQUEST";
export const DELETE_TOPN_COLOR_SUCCESS = "DELETE_TOPN_COLOR_SUCCESS";
export const DELETE_TOPN_COLOR_FAILURE = "DELETE_TOPN_COLOR_FAILURE";

